import { render, staticRenderFns } from "./design_note_pin.vue?vue&type=template&id=beeac48c"
import script from "./design_note_pin.vue?vue&type=script&lang=js"
export * from "./design_note_pin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports